"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BottomNavigation_1 = __importDefault(require("@material-ui/core/BottomNavigation"));
var BottomNavigation = function (_a) {
    var children = _a.children, classes = _a.classes, _b = _a.component, component = _b === void 0 ? 'div' : _b, onChange = _a.onChange, _c = _a.showLabels, showLabels = _c === void 0 ? false : _c, value = _a.value;
    return (react_1.default.createElement(BottomNavigation_1.default, { classes: classes, component: component, onChange: onChange, showLabels: showLabels, value: value }, children));
};
exports.default = BottomNavigation;
